(() => {
  'use strict';
  const rules = window.MisakiBlackGiftRules;
  if (!rules) return;
  const states = new WeakMap();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const thresholds = [10000, 20000, 25000, 30000];
  const words = {
    de: { stages: 'Stufen', ready: 'Geschenk wählbar', all: 'Alle Einkaufsstufen erreicht', review: 'Gewähltes Geschenk prüfen', reached: 'Stufe CHF {amount} erreicht', shortNext: 'Noch CHF {amount} bis CHF {tier}', shortFirst: 'Noch CHF {amount} bis zum Geschenk', chosen: 'Auswahl ändern', chooseShort: 'Wählen', changeShort: 'Ändern', inactive: 'Geschenk wählen · ab CHF 100', basket: 'im Warenkorb' },
    en: { stages: 'tiers', ready: 'Choose your gift', all: 'All purchase tiers reached', review: 'Review your selected gift', reached: 'CHF {amount} tier reached', shortNext: 'CHF {amount} to CHF {tier}', shortFirst: 'CHF {amount} to your gift', chosen: 'Change selection', chooseShort: 'Choose', changeShort: 'Change', inactive: 'Choose gift · from CHF 100', basket: 'in your cart' },
    fr: { stages: 'paliers', ready: 'Cadeau disponible', all: 'Tous les paliers atteints', review: 'Vérifiez le cadeau choisi', reached: 'Palier CHF {amount} atteint', shortNext: 'Encore CHF {amount} pour CHF {tier}', shortFirst: 'Encore CHF {amount} pour votre cadeau', chosen: 'Modifier le choix', chooseShort: 'Choisir', changeShort: 'Modifier', inactive: 'Choisir · dès CHF 100', basket: 'dans votre panier' },
    it: { stages: 'soglie', ready: 'Regalo disponibile', all: 'Tutte le soglie raggiunte', review: 'Verifichi il regalo scelto', reached: 'Soglia CHF {amount} raggiunta', shortNext: 'CHF {amount} per CHF {tier}', shortFirst: 'CHF {amount} per il Suo regalo', chosen: 'Modificare la scelta', chooseShort: 'Scegliere', changeShort: 'Modificare', inactive: 'Scegliere · da CHF 100', basket: 'nel carrello' }
  };
  const money = amount => (amount / 100).toLocaleString('de-CH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const setText = (box, selector, value) => box.querySelectorAll(selector).forEach(element => { if (element.textContent !== value) element.textContent = value; });
  function render(box, { cart, choice, tier, language }) {
    const copy = words[language] || words.en;
    const chf = cart?.currency === 'CHF';
    const amount = chf ? tier.amount : null;
    const reached = chf ? tier.reached : 0;
    box.querySelector('progress').setAttribute('aria-valuetext', amount === null ? '…' : `CHF ${money(amount)}. ${reached}/4 ${copy.stages}`);
    const title = box.querySelector('[data-gift-title]');
    const note = box.querySelector('[data-gift-message]').textContent;
    const link = box.querySelector('[data-gift-link]');
    const previous = states.get(box) || { amount: null, reached: 0 };
    const validChoice = choice && chf && rules.selectionEligibility(cart, choice.gift).eligible;
    let headline = title.textContent;
    if (chf && !choice && reached) headline = tier.next ? copy.ready : copy.all;
    if (choice && chf && !validChoice) headline = copy.review;
    let short = note;
    if (chf && !choice) short = tier.next
      ? (reached ? copy.shortNext : copy.shortFirst).replace('{amount}', money(tier.next - amount)).replace('{tier}', String(tier.next / 100))
      : copy.all;
    if (choice && chf && !validChoice) short = copy.review;
    box.classList.toggle('is-ready', chf && reached > 0);
    setText(box, '[data-gift-stage]', `· ${reached}/4 ${copy.stages}`);
    setText(box, '[data-gift-short]', short);
    setText(box, '[data-gift-mobile-detail]', amount === null ? note : `CHF ${money(amount)} ${copy.basket}. ${note}`);
    const toggle = box.querySelector('[data-gift-progress-toggle]');
    if (toggle) toggle.setAttribute('aria-label', amount === null ? note : `Black Gift. CHF ${money(amount)}. ${reached}/4 ${copy.stages}. ${short}`);
    box.querySelectorAll('[data-gift-segment]').forEach(segment => {
      const index = thresholds.indexOf(Number(segment.dataset.giftSegment));
      const start = thresholds[index - 1] || 0;
      const fraction = amount === null ? 0 : Math.max(0, Math.min(1, (amount - start) / (thresholds[index] - start)));
      segment.querySelector('[data-gift-fill]').style.width = `${fraction * 100}%`;
    });
    const label = chf && reached > 0 ? (choice ? copy.chosen : (link.querySelector('[data-gift-link-label]')?.textContent || link.textContent)) : copy.inactive;
    setText(box, '[data-gift-link-label]', label);
    setText(box, '[data-gift-link-short]', choice ? copy.changeShort : copy.chooseShort);
    link.setAttribute('aria-label', label);
    const values = box.querySelectorAll('[data-gift-amount]');
    const paint = value => {
      previous.displayed = value;
      values.forEach(element => { element.textContent = value === null ? '…' : `CHF ${money(value)}`; });
    };
    if (amount !== previous.amount || motion.matches) {
      if (previous.frame) cancelAnimationFrame(previous.frame);
      previous.frame = null;
    }
    if (amount === null || previous.amount === null || motion.matches) paint(amount);
    else if (previous.amount !== amount) {
      const start = performance.now();
      const from = previous.displayed ?? previous.amount;
      const tick = now => {
        const elapsed = motion.matches ? 1 : Math.min(1, Math.max(0, (now - start) / 650));
        previous.displayed = Math.round(from + (amount - from) * (1 - Math.pow(1 - elapsed, 3)));
        paint(previous.displayed);
        if (elapsed < 1) previous.frame = requestAnimationFrame(tick);
        else previous.frame = null;
      };
      previous.frame = requestAnimationFrame(tick);
    } else if (!previous.frame) paint(amount);
    if (amount === null || reached < previous.reached || choice || motion.matches) {
      clearTimeout(previous.timer);
      previous.celebrating = false;
    } else if (previous.amount !== null && reached > previous.reached) {
      clearTimeout(previous.timer);
      previous.celebrating = true;
      previous.celebration = copy.reached.replace('{amount}', String(thresholds[reached - 1] / 100));
      previous.timer = setTimeout(() => {
        previous.celebrating = false;
        if (!box.hidden) title.textContent = previous.headline;
      }, 2800);
    }
    previous.headline = headline;
    title.textContent = previous.celebrating ? previous.celebration : headline;
    previous.amount = amount;
    previous.reached = reached;
    states.set(box, previous);
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-gift-progress-toggle]');
    if (!toggle) return;
    const expanded = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.closest('[data-black-gift-progress]').classList.toggle('is-expanded', expanded);
  });
  window.MisakiBlackGiftProgressView = { render };
})();
